import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './context/LanguageContext';
import { HelmetProvider } from 'react-helmet-async';
import { getStateSnapshot } from './services/publicContent';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </HelmetProvider>
  </React.StrictMode>
);

/**
 * Called by react-snap before serialising each route. The return value is
 * written into the HTML as `window.__UDENT_STATE__` and read back by
 * services/publicContent.js, so pre-rendered pages ship with real content and
 * the client's first render reproduces it exactly.
 */
window.snapSaveState = () => ({ __UDENT_STATE__: getStateSnapshot() });

// When react-snap has pre-rendered this route the container already holds
// markup, so hydrate it instead of throwing it away and re-rendering.
// Falls back to a fresh render for routes that weren't pre-rendered
// (e.g. /admin/*, which is deliberately excluded).
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// Web Vitals — log Core Web Vitals (LCP, CLS, FID/INP, FCP, TTFB) to the
// browser console in development. In production you can replace this with
// a beacon to your analytics endpoint (Google Analytics, Sentry, etc.).
// Google uses Core Web Vitals as a ranking signal.
reportWebVitals(
    process.env.NODE_ENV === 'production'
        ? undefined           // wire up beacon here when analytics is added
        : (metric) => console.log('[web-vitals]', metric.name, metric.value, metric)
);
